import React, { useEffect, useRef, useState } from 'react';
import '../assets/css/custom.css';
import '../assets/css/client.css';
import '../assets/css/font-awesome.css';
import '../assets/css/sweetalert.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/steps.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileAlt,
  faFileUpload,
  faEdit,
  faTimes,
  faHistory,
  faCalendarAlt,
  faBuilding,
  faHome
} from "@fortawesome/free-solid-svg-icons";
// import { faEdit, faPlus, faSort } from '@fortawesome/free-solid-svg-icons';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Link, useNavigate } from 'react-router-dom';
import ReactDOM from "react-dom";
// import { Wizard, Steps, Step, WithWizard } from "react-multistep-wizard";
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import { Stepper, Step, StepLabel } from '@mui/material';
import { Textarea } from '@material-tailwind/react';
import { ChatBubble, Circle, TempleHinduOutlined } from '@mui/icons-material';
import { commonAPI } from "../services/CommonAPIService"
import { ErrorSource } from '../common/constants'
import Menus from "./menus";
import Multiselect from 'multiselect-react-dropdown';
import Action from '../assets/img/Action.png';
import BroadCastImg from '../assets/img/megaphones.png';
import chat from '../assets/img/sent.png';
import noticeApproval from '../assets/img/noticeapproval.png';
import ChatBubbleIcon from '../assets/img/chat.png';
import JoditEditor from 'jodit-react';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';
import FlatIcon from '../assets/img/config-flat.png';
import { faBullhorn, faPodcast } from '@fortawesome/fontawesome-free-solid';
import noPictures from '../assets/img/no-pictures.png';
import noticeuserupload from '../assets/img/noticeuserupload.png';
import noticeImageUpload from '../assets/img/noticeImageUpload.png';



function NoticeApproval() {
  const history = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const steps = ['Step 1', 'Step 2', 'Step 3'];
  const [Show, setShow] = useState(false);
  const [ApproveShow, setApproveShow] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [NoticeList, setNoticeList] = useState("");
  const [TowerList, setTowerList] = useState("");
  const [TowerListGet, setTowerListGet] = useState("");
  const [FlatList, setFlatList] = useState([]);
  const [FlatListGet, setFlatListGet] = useState([]);
  const [FamilyList, setFamilyList] = useState("");
  const [NoticeSubject, setNoticeSubject] = useState("");
  const [NoticeDescription, setNoticeDescription] = useState("");
  const [NoticeEmail, setNoticeEmail] = useState();
  const [Importance, setImportance] = useState();
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [NoticeType, setNoticeType] = useState([]);
  const [NoticeTypeId, setNoticeTypeId] = useState("");
  const [NoticeStatus, setNoticeStatus] = useState();
  const [NoticeTypeText, setNoticeTypeText] = useState("");
  const [NoticeId, setNoticeId] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageTwo, setSelectedImageTwo] = useState(null)
  const [firstSectionButton, setFirstSectionButton] = useState(false);
  const [TowerFlatArry, setTowerFlatArry] = useState([]);
  const [CurrentStatusSelected, setCurrentStatusSelected] = useState("PENDING");
  const [UserData, setUserData] = useState("");
  const [TowerSelected, setTowerSelected] = useState([]);
  const [FlatSelected, setFlatSelected] = useState([]);
  const [tower_, setTower_] = useState("");
  const [Flat_, setFlat_] = useState("");
  const [NoticeImages, setNoticeImages] = useState([]);
  const [NoticeAddId, setNoticeAddId] = useState("");
  const [ApproverComment, setApproverComment] = useState([]);
  const [ApproverCommentInput, setApproverCommentInput] = useState("");
  const [fullscreen, setFullscreen] = useState(true);
  const editor = useRef(null);
  const [content, setContent] = useState('');
  const [updatedTowerItem, setUpdatedTowerItem] = useState(null);
  const [removedTowerItem, setRemovedTowerItem] = useState(null);
  const [updatedFlatItem, setUpdatedFlatItem] = useState(null);
  const [removedFlatItem, setRemovedFlatItem] = useState(null);
  const [CommentShowHide, setCommentShowHide] = useState(false);
  const [SearchNotice, setSearchNotice] = useState("");
  const [OldNoticeData, setOldNoticeData] = useState("");
  const [isBroadcastModal, setIsBroadcastModal] = useState(false)
  const [IsUpdateMode, setIsUpdateMode] = useState(false);
  const [UploadBtn, setUploadBtn] = useState(false);
  const [selectedImageTwoShow, setSelectedImageTwoShow] = useState(null);
  const [selectedImageType, setSelectedImageType] = useState("");
  const [UpdateNoticeBtn, setUpdateNoticeBtn] = useState(false);
  const [broadcastHistoryShow, setBroadcastHistoryShow] = useState(false);
  const [broadcastHistoryData, setBroadcastHistoryData] = useState([]);
  const [selectedNoticeForHistory, setSelectedNoticeForHistory] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [UploadDocBtn, setUploadDocBtn] = useState(false);



  // Open for Approval only
  const openApproval = (item) => {
    // populate fields...
    setUpdateNoticeBtn(false);
    setApproveShow(true);
  };

  // Open for Edit
  const openEdit = (item) => {
    // populate fields...
    setUpdateNoticeBtn(true);
    setApproveShow(true);
  };

  const populateModal = (item) => {
    setNoticeId(item.noticeId);
    setNoticeAddId(item.noticeId);
    setNoticeSubject(item.noticeSubject);
    setContent(item.noticeDescription);
    setImportance(item.importance);
    setStartDate(convertISSet(item.effectiveStartDt));
    setEndDate(convertISSet(item.effectiveEndDt));

    // Fix: Set separately
    setNoticeTypeId(item.noticeTypeId || "");
    setNoticeTypeText(item.noticeTypeText || "");

    setApproverComment((item.approverComment || '').split('\r\n').filter(Boolean));
    setApproverCommentInput('');
    setSelectedImageTwo(null);
    setSelectedImageTwoShow(null);
    setUploadBtn(false);
  };

  // console.log("TowerSelected@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@", TowerSelected)

  // console.log("Tower Id", updatedTowerItem)

  useEffect(() => {
    const storedUsername = localStorage.getItem('userData');
    console.log("useEffect Local storage name", storedUsername)
    if (storedUsername) {
      // If the username is present, redirect to the dashboard
      history('/Approval');
      console.log("useEffect Local storage Yes")
    }
    else if (storedUsername === null) {
      history('/');
      console.log("useEffect Local storage No")
    }
  }, [history]);

  useEffect(() => {
    if (ApproverCommentInput.length == 0) {
      setCommentShowHide(false);
    } else {
      setCommentShowHide(true);
    }
  }, [ApproverCommentInput])

  console.log("CUrrent status is", CurrentStatusSelected)

  const handleFileInputChangeTwo = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!/\.(jpeg|jpg|png)$/i.test(file.name)) {
        toast.error("Please select an image in JPEG, JPG, or PNG format.");
        return;
      }
      if (file.size >= 512000) {
        toast.error("Please select an Image below 500kb size.");
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;  // base64 with prefix
        setSelectedImageTwo(base64String); // for preview and API
        setSelectedImageTwoShow(base64String); // full base64 with prefix if backend expects it
        setUploadBtn(true);
      };
      reader.readAsDataURL(file);
    }
  };


  const AddNoticeImage = async () => {
    const bodydata = {
      "modifiedUserId": JSON.stringify(UserData?.userId),
      "noticeId": NoticeId,
      "docImage": selectedImageTwoShow  // This is the base64 without prefix
    };

    try {
      setLoading(true);
      const endPointVariableKey = {
        urlVariable: null,
        buildingId: UserData?.buildingId
      };

      if (!selectedImageTwo) {
        toast.warning("Please select an image to upload");
        setLoading(false);
        return;
      }

      let response = await commonAPI("NoticeImagesAdd", bodydata, endPointVariableKey);

      if (response?.success === true && response?.message?.length == 0) {
        toast.success("Image uploaded successfully");
        setUploadBtn(false);
        GetNoticeImages(); // Refresh images
        setSelectedImageTwo(null);
        setSelectedImageTwoShow(null);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(response?.message?.[0] || "Failed to upload image");
      }
    } catch (error) {
      setLoading(false);
      toast.error("Error uploading image");
      console.error("Upload error:", error);
    }
  };

  const GetBroadcastHistory = async (noticeId) => {
    try {
      setLoading(true);
      const auth = localStorage.getItem("userData");
      const myUserData = JSON.parse(auth);

      const endPointVariableKey = {
        urlVariable: noticeId,
        buildingId: myUserData?.buildingId
      };

      let response = await commonAPI("NoticeRecipientHistory", undefined, endPointVariableKey);

      if (response?.success === true) {
        setBroadcastHistoryData(response?.data || []);
      } else {
        toast.error("No broadcast history found");
        setBroadcastHistoryData([]);
      }
    } catch (error) {
      console.error("Error fetching broadcast history:", error);
      toast.error("Failed to load history");
      setBroadcastHistoryData([]);
    } finally {
      setLoading(false);
    }
  };

  const openBroadcastHistory = (item) => {
    setSelectedNoticeForHistory(item);
    setBroadcastHistoryShow(true);
    GetBroadcastHistory(item.noticeId);
  };



  const convertTimePost = (date) => {
    if (!date) return "";
    const [yyyy, mm, dd] = date.split("-");
    return `${mm}/${dd}/${yyyy}`;
  };

  const UpdateNoticeData = async () => {
    const bodydata = {
      "noticeId": NoticeId,
      "noticeSubject": NoticeSubject,
      "noticeDescription": content,
      "noticeTypeId": NoticeTypeId,           // Now correct
      "noticeTypeText": NoticeTypeText,       // Now correct
      "importance": Importance,
      "effectiveStartDt": convertTimePost(StartDate),
      "effectiveEndDt": convertTimePost(EndDate),
      "modifiedUserId": JSON.stringify(UserData?.userId),
    };



    try {
      setLoading(true);
      const endPointVariableKey = { urlVariable: null, buildingId: UserData?.buildingId };
      let response = await commonAPI("NoticeUpdate", bodydata, endPointVariableKey);

      if (response.success === true && response.message.length == 0) {
        toast.success("Notice Updated");
        GetNoticeList();
        setIsUpdateMode(false);  // Exit update mode
        setLoading(false);
      } else {
        toast.error(response.message[0]);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error("Error updating notice");
    }
  }




  // console.log("towerSelect", TowerSelected, "flatSelected", FlatSelected);

  // console.log("flat list data", FlatList)
  // console.log("flatSelected", FlatSelected);

  const options = [
    { value: 'chocolate', label: 'Chocolate', id: '1' },
    { value: 'strawberry', label: 'Strawberry', id: '2' },
    { value: 'vanilla', label: 'Vanilla', id: '3' }
  ]

  useEffect(() => {
    // GetFlatList();
    if (TowerSelected.length) {
      console.log("i am run")
      const temp = TowerSelected.map((item) => {
        return {
          towerId: item.id,
          flatId: null
        }
      })
      setTower_(temp)
    }

  }, [TowerSelected])
  // console.log("this is towerSelected, ", tower_)

  const BroadCastMeseg = (item) => {
    setShow(true)
    console.log("item", item)
    setNoticeSubject(item.noticeSubject)
    setNoticeDescription(item.noticeDescription)
    setNoticeTypeId(item.noticeTypeId)
    setNoticeTypeText(item.noticeTypeText)
    setNoticeStatus(item.currentStatus)
    setNoticeEmail(item.notifyOnEmail == true ? "Yes" : "No")
    setImportance(item.importance)
    setStartDate(item.effectiveStartDt)
    setEndDate(item.effectiveEndDt)
    setSelectedImage()
    setSelectedImageTwo();
    // GetPublishList();
  };

  const openCreateModal = () => {
    setShow(true)
    setNoticeSubject("")
    setNoticeDescription("")
    setNoticeEmail("")
    setImportance("")
    setStartDate("")
    setEndDate("")
    setSelectedImage("")
    setSelectedImageTwo("");
  }

  function ImageUpload() {
    const [selectedImage, setSelectedImage] = useState(null);

    const handleFileInputChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          setSelectedImage(reader.result);
        };
        reader.readAsDataURL(file);
      }
    };
  }

  const convertISTTime = (date) => {
    if (date != null || date != "" || date != undefined) {
      const [datePart, TimePart] = date.split(" ");
      const [mm, dd, yyyy] = datePart.split("/");
      // const [hh, mn, ss] = TimePart.split(':')
      const formatedTime = `${dd}-${mm}-${yyyy}`;
      return formatedTime;
    } else {
      console.warn("input date string may be null, empty string or undefined");
    }
  }

  const convertISSet = (date) => {
    if (date != null || date != "" || date != undefined) {
      let [datePart, TimePart] = date.split(" ");
      let [mm, dd, yyyy] = datePart.split("/");
      // const [hh, mn, ss] = TimePart.split(':')
      // if(mm<10){mm.padStart(2, "0")};
      // if(dd<10){dd.padStart(2, "0")};
      if (mm < 10) {
        mm = "0" + mm
      }
      if (dd < 10) {
        dd = "0" + dd
      }
      const formatedTime = `${yyyy}-${mm}-${dd}`;
      return formatedTime;
    } else {
      console.warn("input date string may be null, empty string or undefined");
    }
  }

  // Helper function to get today's date in mm/dd/yyyy format
  const getTodayDate = () => {
    const today = new Date();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const dd = String(today.getDate()).padStart(2, '0');
    const yyyy = today.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  // Get yesterday's date in dd/mm/yyyy format
  const getYesterdayDate = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const dd = String(yesterday.getDate()).padStart(2, '0');
    const mm = String(yesterday.getMonth() + 1).padStart(2, '0');
    const yyyy = yesterday.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };





  const GetNoticeList = async () => {
    // const bodydata = { 
    //     "noticeId": 0,
    //     "currentStatus": CurrentStatusSelected,
    //     "validUpto": getTodayDate()
    //   };

    const bodydata = {
      "noticeId": 0,
      "currentStatus": CurrentStatusSelected === "EXPIRED" ? "APPROVED" : CurrentStatusSelected,
      "validUpto": CurrentStatusSelected === "EXPIRED" ? null : getTodayDate(),
      "effectiveEndDt": CurrentStatusSelected === "EXPIRED" ? getYesterdayDate() : null
    };
    try {
      const auth = localStorage.getItem("userData");
      const myUserData = JSON.parse(auth);
      setUserData(myUserData);
      console.log("myuserData", myUserData)
      const endPointVariableKey = {
        urlVariable: null,
        buildingId: myUserData?.buildingId
      }
      let Key = 'Notice';
      if (CurrentStatusSelected === "EXPIRED") {
        Key = "ExpiredNoticeList"
      }

      let response = await commonAPI(Key, bodydata, endPointVariableKey)
      // console.log("Notice List", response?.data)
      if (response?.success === true) {
        console.log("NoticeList====================", response, bodydata)
        setNoticeList(response?.data);
        setOldNoticeData(response?.data);
      } else {
        toast.error("Something went wrong");
      }

    } catch (error) {
      console.log(error);
      setLoading(false);
      const bodyError = {
        "userId": UserData?.userId,
        "mobileNumber": UserData?.mobileNumber, // Need to be change
        "requestJSON": bodydata,
        "uri": "/api/Master/Notice",
        "errorNumber": "NL01",
        "errorSource": ErrorSource,
        "errorSummary": error?.message,
        "errorDescription": error?.message,
        "fileClassName": "NoticeApproval.js",
        "functionName": "GetNoticeList",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError)

      if (response?.success === true & response?.message?.length == null) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        toast.error("Something went wrong");
        setLoading(false);
      }
    }

  }

  function filterNoticeData(text) {
    setSearchNotice(text);

    const newData = OldNoticeData?.filter(item => {
      const formattedEffectiveEndDt = item?.effectiveEndDt ? convertISTTime(item?.effectiveEndDt) : '';
      return (
        item?.noticeSubject?.toLowerCase().includes(text?.toLowerCase()) ||
        // towerFlatCombined.toLowerCase().includes(text?.toLowerCase()) ||
        item?.noticeTypeText?.toLowerCase().includes(text?.toLowerCase()) ||
        formattedEffectiveEndDt?.includes(text)
      );
    });

    setNoticeList(newData);
  }

  const [DeleteShowImg, setDeleteShowImg] = useState(false);
  const [DeleteItem, setDeleteItem] = useState(null);

  const ShowDeleteImgModal = (item) => {
    setDeleteItem(item);
    setDeleteShowImg(true);
  };

  const DeleteNoticeImages = async () => {
    if (!DeleteItem) return;
    const bodydata = {
      modifiedUserId: JSON.stringify(UserData?.userId),
      noticeDocId: DeleteItem.noticeDocId,
      noticeId: DeleteItem.noticeId,
    };
    try {
      setLoading(true);
      const endPointVariableKey = { urlVariable: null, buildingId: UserData?.buildingId };
      let response = await commonAPI("NoticeImagesDelete", bodydata, endPointVariableKey);
      if (response?.success === true && response?.message?.length === 0) {
        toast.success("Image Deleted");
        setLoading(false);
        setDeleteShowImg(false);
        GetNoticeImages(); // Refresh images after delete
      } else {
        toast.error(response?.message[0]);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error("Failed to delete image");
    }
  };


  const GetNoticeImages = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      urlVariable: NoticeId,
      buildingId: myUserData?.buildingId
    }
    try {
      setLoading(true);
      let response = await commonAPI("NoticeImages", undefined, endPointVariableKey)
      if (response?.success === true && response?.message?.length == 0) {
        console.log("Notice Get Images", response)
        setNoticeImages(response?.data)
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something went wrong");
      }

    } catch (error) {
      console.log(error);
      setLoading(false);
      const bodyError = {
        "userId": UserData?.userId,
        "mobileNumber": UserData?.mobileNumber, // Need to be change
        "requestJSON": null,
        "uri": "/api/Master/Notice/Images",
        "errorNumber": "NI01",
        "errorSource": ErrorSource,
        "errorSummary": error?.message,
        "errorDescription": error?.message,
        "fileClassName": "Noticemanagement.js",
        "functionName": "GetNoticeImages",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError)

      if (response?.success === true && response?.message?.length == 0) {
        toast.error("Something went wrong ");
        setLoading(false);
      } else {
        toast.error("Something went wrong ");
        setLoading(false);
      }
    }

  }

  useEffect(() => {
    if (NoticeId) {
      GetNoticeImages();
    }
  }, [NoticeId, ApproveShow]);


  useEffect(() => {
    if (NoticeId && !isBroadcastModal) {  // Only run if NOT broadcast modal
      GetPublishList()
    }
  }, [NoticeId, Show])

  const GetNoticeType = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      urlVariable: null,
      buildingId: myUserData?.buildingId
    }
    try {
      let response = await commonAPI("NoticeType", undefined, endPointVariableKey)
      console.log("Notice List", response?.data)
      if (response?.success === true) {
        console.log("NoticeType", response)
        setNoticeType(response?.data)
      } else {
        toast.error("Something went wrong");
      }

    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }

  }

  const GetTowerList = async () => {
    try {
      const auth = localStorage.getItem("userData");
      const myUserData = JSON.parse(auth);
      setUserData(myUserData);
      console.log("myuserData", myUserData)
      const endPointVariableKey = {
        urlVariable: null,
        buildingId: myUserData.buildingId
      }
      let response = await commonAPI("Tower", undefined, endPointVariableKey)
      // console.log("Tower List", response?.data)
      if (response?.success === true) {
        console.log("tower]]]]]]]]]]", response)
        setTowerListGet(response?.data)
        const tempData = response?.data.map((item) => { return { value: item?.towerId, label: item?.towerName, } });
        setTowerList(tempData);
        // console.log("tower]]]]]]]]]]", tempData)


        // for(var k=0;k<noticeRecipientTransitData.length;k++){

        // }

        // var count = Object.keys(response.responseData.transports).length;
        // let transportValue = [];
        // for (var i = 0; i < count; i++) {
        //     transportValue.push({
        //     value: response.responseData.transports[i],
        //     });
        // }

      } else {
        toast.error("Something went wrong");
      }

    } catch (error) {
      console.log(error);
      setLoading(false);
      const bodyError = {
        "userId": UserData?.userId,
        "mobileNumber": UserData?.mobileNumber, // Need to be change
        "requestJSON": "",
        "uri": "/api/Master/Notice",
        "errorNumber": "NL01",
        "errorSource": ErrorSource,
        "errorSummary": error?.message,
        "errorDescription": error?.message,
        "fileClassName": "Noticemanagement.js",
        "functionName": "GetNoticeList",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError)

      if (response?.success === true & response?.message?.length == null) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        toast.error("Something went wrong");
        setLoading(false);
      }
    }

  }

  const GetFlatList = async () => {

    console.log("this function run")
    try {
      const auth = localStorage.getItem("userData");
      const myUserData = JSON.parse(auth);
      setUserData(myUserData);
      console.log("myuserData", myUserData)
      const endPointVariableKey = {
        urlVariable: null,
        buildingId: myUserData?.buildingId
      }
      let response = await commonAPI("Flat", undefined, endPointVariableKey)
      // console.log("Flat List", response?.data)
      if (response?.success === true) {
        console.log("Flat List", response)
        setFlatListGet(response?.data)
        // console.log("updatedValue", updatedTowerItem)
        setRemovedTowerItem(null);
        const temp_Data = response?.data.filter(item => item.towerId == updatedTowerItem?.value);
        // const tempDataFlat = response?.data?.map((item) => {return {value: item.flatId, label: item.flatName}});
        const tempDataFlat = temp_Data?.map((item) => { return { value: item?.flatId, label: `${item?.towerName} - ${item?.flatName}`, towerId: item?.towerId } });
        console.log("Flat IS THERE", temp_Data);
        // setFlatList(tempDataFlat);
        // setFlaList((prev) =>  )
        setFlatList((prev) => (prev ? prev.concat(tempDataFlat) : tempDataFlat));                // setFlatList(tempDataFlat);

        return;

        // var count = Object.keys(FlatListGet[i]?.towerId).length;
        const dataFlat = response?.data;
        const TowerFlat = [];
        setTowerFlatArry(TowerFlat);
        for (var i = 0; i < dataFlat.length; i++) {
          var dateGet = false;
          var tower = {};
          for (var j = 0; j < TowerFlat.length; j++) {
            if (TowerFlat[j].towerId == dataFlat[i].towerId) {
              dateGet = true;
              tower = TowerFlat[j];
              break;
            }
          }
          if (dateGet == true) {
            tower.flats.push(dataFlat[i]);
          } else {
            tower.towerId = dataFlat[i].towerId;
            tower.display = false;
            tower.flats = [];
            tower.flats.push(dataFlat[i]);
            TowerFlat.push(tower);
          }
        }

        console.log("TowerFlatArry", TowerFlat)

        const SelectedTowerArry = [];
        const FilterFlatArry = [];
        for (var k = 0; k < TowerSelected.length; k++) {
          SelectedTowerArry.push(TowerSelected[k].id);
        }
        for (var j = 0; j < TowerFlatArry.length; j++) {
          TowerFlatArry[j].display = false;
          if (SelectedTowerArry.indexOf(TowerFlatArry[j].towerId) !== -1) {
            TowerFlatArry[j].display = true;
            FilterFlatArry.push(TowerFlatArry[j].flats)
          }
        }

        const FilterFlatListArry = [];
        for (var l = 0; l < FilterFlatArry.length; l++) {
          FilterFlatListArry.push(FilterFlatArry[l]);
        }

        let concatenatedArray = [];
        for (let i = 0; i < FilterFlatListArry.length; i++) {
          concatenatedArray = concatenatedArray.concat(FilterFlatListArry[i]);
        }
        console.log("this is concatanated array", concatenatedArray)

        const Temp_ = FilterFlatListArry?.map((item) => {
          return {
            flatId: item?.flatId,
            towerId: item?.towerId
          }
        })
        setFlat_(Temp_);

        const tempData = concatenatedArray?.map((item) => { return { value: item.flatId, label: item.flatName } });
        setFlatList(tempData);
        console.log("FilterFlatArry0000000000", FilterFlatListArry)
        // const filterDataFlat = FilterFlatArry[0]?.map((item) => {return {name: item?.flatName, id: item?.flatId}});
        // setFlatList(filterDataFlat)
        // const selectFlatObj = [];
        // for(var l=0;l<TowerSelected.length;l++){
        //     for(var m=0;m<selectFlatObj.length;m++){
        //         // if(selectFlatObj[m].towerId==TowerSelected[l].towerId){
        //         //     // exists=true;
        //         //     // setFlatList(selectFlatObj)
        //         //     // break;
        //         // }
        //     }
        // }   
        // console.log("selectedFlatObj*********", selectFlatObj) 
        // const tempDataFlatFilter = response?.data?.filter(item => item.towerId == TowerSelected,);
        // const temp_DataFilter = TowerListGet.filter(item => item.towerId == temp_Data,);
      } else {
        toast.error("Something went wrong");
      }

    } catch (error) {
      console.log(error);
      setLoading(false);
      const bodyError = JSON.stringify({
        "userId": UserData?.userId,
        "mobileNumber": UserData?.mobileNumber, // Need to be change
        "requestJSON": "",
        "uri": "/api/Master/Notice",
        "errorNumber": "NL01",
        "errorSource": ErrorSource,
        "errorSummary": error?.message,
        "errorDescription": error?.message,
        "fileClassName": "Noticemanagement.js",
        "functionName": "GetNoticeList",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError)

      if (response?.success === true & response?.message?.length == null) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        toast.error("Something went wrong");
        setLoading(false);
      }
    }

  }

  useEffect(() => {
    GetNoticeType();
    GetTowerList();
    GetFlatList();
    // GetFlatList();
    // GetPublishList();
  }, [])

  useEffect(() => {
    if (updatedTowerItem) {
      console.log("flatlist set on tower update")
      GetFlatList();
    }
  }, [updatedTowerItem])


  useEffect(() => {
    GetNoticeList();
  }, [CurrentStatusSelected])



  const GetPublishList = async () => {
    try {
      const auth = localStorage.getItem("userData");
      const myUserData = JSON.parse(auth);
      setUserData(myUserData);
      console.log("myuserData", myUserData)
      const endPointVariableKey = {
        urlVariable: NoticeId,
        buildingId: myUserData.buildingId
      }
      let response = await commonAPI("NoticeRecipient", undefined, endPointVariableKey)
      console.log("Notice Recipient List", response?.data)
      if (response?.success === true) {
        // console.log("Notice Recipient", response);
        const selectedTowers = [];
        const noticeRecipientTransitData = response?.data?.noticeRecipientTransitData;


        // console.log("selected=================", TowerListGet);

        for (var k = 0; k < noticeRecipientTransitData.length; k++) {
          for (var l = 0; l < TowerListGet.length; l++) {
            if (noticeRecipientTransitData[k].towerId == TowerListGet[l].towerId) {
              var exists = false;
              for (var m = 0; m < selectedTowers.length; m++) {
                if (selectedTowers[m].towerId == TowerListGet[l].towerId) {
                  exists = true;
                  break;
                }
              }
              if (exists == false) {
                const selectedTowersObj = {};
                selectedTowersObj.towerId = noticeRecipientTransitData[k].towerId;
                selectedTowersObj.towerName = TowerListGet[l].towerName;
                selectedTowers.push(selectedTowersObj);
              }
              break;
            }
          }
        }
        // console.log("selected=================", noticeRecipientTransitData,  selectedTowers, TowerListGet);
        const tempData = selectedTowers?.map((item) => { return { value: item?.towerId, label: item?.towerName } });
        console.log("temporary data", tempData)
        const selectedFlat = [];
        if (tempData?.length == 0) {
          setTowerSelected([]);
        } else {
          setTowerSelected(tempData);
        }
        // for(let i = 0; i<=tempData.length; i++){
        //     setUpdatedTowerItem({value:tempData[i].value,label:tempData[i].label})
        // }

        // console.log("selected=================", tempData);
        console.log("noticeRecipientTransitData - ", noticeRecipientTransitData);
        console.log("FlatListGet - ", FlatListGet);
        console.log(FlatListGet);
        for (var k = 0; k < noticeRecipientTransitData.length; k++) {
          for (var l = 0; l < FlatListGet.length; l++) {
            if (noticeRecipientTransitData[k].flatId == FlatListGet[l].flatId) {
              var exists = false;
              for (var m = 0; m < selectedFlat.length; m++) {
                if (selectedFlat[m].flatId == FlatListGet[l].flatId) {
                  exists = true;
                  break;
                }
              }
              if (exists == false) {
                const selectedFlatObj = {};
                selectedFlatObj.flatId = noticeRecipientTransitData[k].flatId;
                selectedFlatObj.flatName = FlatListGet[l].flatName;
                selectedFlatObj.towerName = FlatListGet[l].towerName;
                selectedFlatObj.towerId = FlatListGet[l].towerId;
                selectedFlat.push(selectedFlatObj);
                console.log("selectedFlatObj", selectedFlatObj)
              }
              break;
            }
          }
        }
        console.log("selected=================", selectedFlat);
        const tempDataFlat = selectedFlat?.map((item) => { return { value: item.flatId, label: `${item?.towerName} - ${item?.flatName}`, towerId: item?.towerId } });
        console.log("selected=================@@@@@@@", tempDataFlat);
        setFlatSelected(tempDataFlat);







      } else {
        toast.error("Something went wrong");
      }

    } catch (error) {
      console.log(error);
      setLoading(false);
      const bodyError = {
        "userId": UserData?.userId,
        "mobileNumber": UserData?.mobileNumber, // Need to be change
        "requestJSON": "",
        "uri": "/api/Master/Notice",
        "errorNumber": "NL01",
        "errorSource": ErrorSource,
        "errorSummary": error?.message,
        "errorDescription": error?.message,
        "fileClassName": "Noticemanagement.js",
        "functionName": "GetNoticeList",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError)

      if (response?.success === true & response?.message?.length == null) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        toast.error("Something went wrong");
        setLoading(false);
      }
    }

  }

  useEffect(() => {
    if (NoticeId) {
      // Currently no need to load flats and tower on mounting, so commenting out the line.
      // GetPublishList()
      // toast.error("publice Fuc Call");
    }
  }, [NoticeId, Show])


  // handle remove item for tower list
  useEffect(() => {
    if (removedTowerItem) {
      // console.log("removed")
      setUpdatedTowerItem(null);
      console.log("removed item", removedTowerItem);
      const temp_Data = FlatListGet?.filter(item => item.towerId == removedTowerItem?.value);
      console.log("temp Data", temp_Data);
      console.log("FlatList", FlatList);
      const tempDataFlat = temp_Data?.map((item) => { return { value: item?.flatId, label: item?.flatName } });
      const filteredMasterState = FlatList?.filter(
        item => !tempDataFlat.some(tempItem => tempItem.value === item.value)
      );
      setFlatList(filteredMasterState);
      console.log("flatList value", filteredMasterState)

      if (FlatSelected) {
        const filteredState = FlatSelected?.filter(
          item => !tempDataFlat?.some(tempItem => tempItem?.value === item?.value)
        );
        setFlatSelected(filteredState);

      }
    }

  }, [removedTowerItem])

  //   handle on change for towerList
  const handleTowerChange = (selectedOptions) => {
    console.log("Selected Options are", selectedOptions)
    if (selectedOptions.length > TowerSelected.length) {
      const addedItem = selectedOptions.find(
        item => !TowerSelected.some(selected => selected.value === item.value)
      );
      console.log('Added item:', addedItem);

      setUpdatedTowerItem(addedItem);
    }

    if (selectedOptions.length < TowerSelected.length) {
      const removedItem = TowerSelected.find(
        item => !selectedOptions.some(selected => selected.value === item.value)
      );
      console.log('Removed item:', removedItem);
      setRemovedTowerItem(removedItem);

    }

    setTowerSelected(selectedOptions);
  };


  //   handle on change for flatList
  const handleFlatChange = (selectedOptions) => {
    console.log("selected option for flat", selectedOptions)
    if (selectedOptions.length > TowerSelected.length) {
      const addedItem = selectedOptions.find(
        item => !FlatSelected.some(selected => selected.value === item.value)
      );
      console.log('Added item:', addedItem);

      setUpdatedFlatItem(addedItem);
    }

    if (selectedOptions.length < FlatSelected.length) {
      const removedItem = FlatSelected.find(
        item => !selectedOptions.some(selected => selected.value === item.value)
      );
      console.log('Removed item:', removedItem);
      setRemovedFlatItem(removedItem);

    }

    setFlatSelected(selectedOptions);
  };

  //handle remove item for flatList

  //   useEffect(() =>{
  //     if(removedFlatItem){

  //     }

  // }, [removedTowerItem])


  const checkBox = [
    // options: [{name: 'Option 1', id: 1},{name: 'Option 2️', id: 2}],
    TowerList
  ];
  // onSelect(selectedList, selectedItem) {
  //     console.log("selected or unsec", selectedList, selectedItem)
  // }  



  // onRemove(selectedList, removedItem) {
  //     ...
  // }

  const FlatcheckBox = {
    // options: [{name: 'Option 1', id: 1},{name: 'Option 2️', id: 2}],
    options: FlatList
  };

  const BroadCast = async () => {
    let body_Data;
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    setUserData(myUserData);
    console.log("myuserData", myUserData)
    if (TowerSelected.length == 0 && FlatSelected.length == 0) {
      body_Data = [{
        "towerId": null,
        "flatId": null
      }]
    } else if (TowerSelected.length && FlatSelected.length == 0) {
      body_Data = TowerSelected.map((item) => ({
        "towerId": item?.value,
        "flatId": null
      }));
    } else {
      body_Data = FlatSelected?.map((item) => ({
        "towerId": item?.towerId,
        "flatId": item?.value
      }))
    }


    const bodydata = {
      "noticeId": NoticeId,
      "createdUserId": JSON.stringify(myUserData?.userId),
      "noticeRecipientTransitData": body_Data
    }

    console.log("bodyRequest", bodydata)

    try {
      setLoading(true);
      const endPointVariableKey = {
        urlVariable: null,
        buildingId: myUserData.buildingId
      }
      let response = await commonAPI("NoticeRecipientAdd", bodydata, endPointVariableKey)
      console.log("NoticeRecipientAdd", response)
      if (response?.success === true) {
        setLoading(false);
        // console.log("tower]]]]]]]]]]", response)
        toast.success("Notice broadcast successfully");
        setShow(false)
        setTowerSelected([]);  // Clear again
        setFlatSelected([]);
        setFlatList([]);

        // for(var k=0;k<noticeRecipientTransitData.length;k++){

        // }

        // var count = Object.keys(response.responseData.transports).length;
        // let transportValue = [];
        // for (var i = 0; i < count; i++) {
        //     transportValue.push({
        //     value: response.responseData.transports[i],
        //     });
        // }

      } else {
        toast.error("Something went wrong");
      }

    } catch (error) {
      console.log(error);
      setLoading(false);
      const bodyError = {
        "userId": UserData?.userId,
        "mobileNumber": UserData?.mobileNumber, // Need to be change
        "requestJSON": "",
        "uri": "/api/Master/Notice",
        "errorNumber": "NL01",
        "errorSource": ErrorSource,
        "errorSummary": error?.message,
        "errorDescription": error?.message,
        "fileClassName": "Noticemanagement.js",
        "functionName": "GetNoticeList",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError)
      console.log("Error", response)
      if (response?.success === true & response?.message?.length == null) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        toast.error("Something went wrong");
        setLoading(false);
      }
    }

  }

  const ApproveModal = (item) => {
    populateModal(item);           // Reuse the function!
    setUpdateNoticeBtn(true);      // Enable update button
    setApproveShow(true);
    setApproveShow(true);
    console.log("itemApproveModal", item)
    setNoticeSubject(item.noticeSubject)
    setContent(item?.noticeDescription)
    setNoticeDescription(item.noticeDescription)
    setNoticeTypeText(item.noticeTypeText)
    setImportance(item.importance)
    setNoticeStatus(item.currentStatus)
    setStartDate(convertISSet(item?.effectiveStartDt))
    setEndDate(convertISSet(item?.effectiveEndDt))
    setNoticeId(item.noticeId)
    setNoticeAddId(item.noticeId)  // ADD THIS LINE
    setSelectedImageTwo(null)  // ADD THIS LINE
    setSelectedImageTwoShow(null)  // ADD THIS LINE

    const approverComment = item?.approverComment.split("\r\n")
    console.log("approverComment", approverComment)
    setApproverComment(approverComment)
    setApproverCommentInput("")
  }



  const BroadCastModal = (item) => {
    setShow(true);
    console.log("itemApproveModal", item)
    setNoticeSubject(item.noticeSubject)
    setContent(item?.noticeDescription)
    setNoticeDescription(item.noticeDescription)
    setNoticeTypeText(item.noticeTypeText)
    setImportance(item.importance)
    setNoticeStatus(item.currentStatus)
    setStartDate(convertISSet(item.effectiveStartDt))
    setEndDate(convertISSet(item.effectiveEndDt))
    setNoticeId(item.noticeId)
    setTowerSelected([])
    setFlatSelected([])
    setFlatList([])
    setUpdatedTowerItem(null)
    setRemovedTowerItem(null)
    setIsBroadcastModal(true);
  }

  const ApproveAPi = async (e) => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      urlVariable: null,
      buildingId: myUserData.buildingId
    }
    setApproveShow(true);
    console.log("e value", e)
    const bodydata = {
      "NoticeId": NoticeId,
      "CurrentStatus": e,
      "ApproverComment": ApproverCommentInput,
      "ApproverUserName": myUserData?.userName,
      "modifiedUserId": myUserData?.userId?.toString(),
      // "modifiedUserId": "RadiusAdmin", // Need to be replaced
    };
    try {
      setLoading(true);
      if (!ApproverCommentInput?.trim()) {
        toast.warning("Please enter Comment");
        setLoading(false)
      } else {
        console.log("body", bodydata);
        let response = await commonAPI("ApproveNotice", bodydata, endPointVariableKey)
        //   const response = await fetch(`http://api-test.curonext.com/api/Master/Building/`, {
        //     // let response = await fetch(`${apiURL}/DAR/DARReportToHOD`, {  
        //       method: "DELETE",
        //       headers: { 'Content-Type': 'application/json'},
        //       body: bodydata

        //   })
        //   const statusCode = response
        console.log("ApproveNotice", response)
        if (response?.success === true & response?.message.length == 0) {
          // toast.success(`Notice ${e}`);  
          // setApproveShow(false);
          // setLoading(false);
          // GetNoticeList();


          if (e == "PENDING") {
            setLoading(false);
            const endPointVariableKey = {
              urlVariable: null,
              buildingId: myUserData.buildingId
            }
            let responsePending = await commonAPI("Notice", bodydata, endPointVariableKey)
            const tempData = responsePending?.data?.filter((item) => item?.noticeId == NoticeId)
            console.log("tempData", tempData)
            const approverComment = tempData[0]?.approverComment?.split("\r\n")
            console.log("approverComment", approverComment)
            setApproverComment(approverComment)
            setApproverCommentInput("")
            toast.success(`Comment Added`);
            setLoading(false);
            GetNoticeList();
            // toast.success(`Vehicle ${e}`);  
          } else {
            setLoading(false);
            const endPointVariableKey = {
              urlVariable: null,
              buildingId: myUserData.buildingId
            }
            let responsePending = await commonAPI("Notice", bodydata, endPointVariableKey)
            const tempData = responsePending?.data?.filter((item) => item?.noticeId == NoticeId)
            console.log("tempData", tempData)
            const approverComment = tempData[0]?.approverComment?.split("\r\n")
            console.log("approverComment", approverComment)
            setApproverComment(approverComment)
            setApproverCommentInput("")
            toast.success(`Notice Rejected`);
            setApproveShow(false);
            setLoading(false);
            GetNoticeList();
          }
        } else {
          toast.error(response.message[0]);
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
      const bodyError = JSON.stringify({
        "userId": UserData.userId,
        "mobileNumber": UserData.mobileNumber, // Need to be change
        "requestJSON": bodydata,
        "uri": "/api/Master/Notice",
        "errorNumber": "DN01",
        "errorSource": ErrorSource,
        "errorSummary": error.message,
        "errorDescription": error.message,
        "fileClassName": "Noticemanagement.js",
        "functionName": "DeleteNotice",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError)

      if (response.success === true && response.message.length == 0) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        toast.error("Something went wrong");
        setLoading(false);
      }

    }

  }

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (ApproverCommentInput) {
        if (event.key === 'Enter') {
          event.preventDefault();  // Prevent default form submission behavior
          ApproveAPi("PENDING");  // Call Login function
        }
      }
    };

    // Attach the event listener
    window.addEventListener('keydown', handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [ApproverCommentInput])

  const ApprovedUser = async (e) => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const endPointVariableKey = {
      urlVariable: null,
      buildingId: myUserData.buildingId
    }
    setApproveShow(true);
    console.log("e value", e)
    const bodydata = {
      "NoticeId": NoticeId,
      "CurrentStatus": "APPROVED",
      "ApproverComment": ApproverCommentInput,
      "ApproverUserName": myUserData.userName,
      "modifiedUserId": myUserData?.userId?.toString(),
      // "modifiedUserId": "RadiusAdmin", // Need to be replaced
    };
    try {
      setLoading(true);
      console.log("body", bodydata);
      let response = await commonAPI("ApproveNotice", bodydata, endPointVariableKey)
      if (response?.success === true && response?.message.length == 0) {

        setLoading(false);
        const endPointVariableKey = {
          urlVariable: null,
          buildingId: myUserData.buildingId
        }
        let responsePending = await commonAPI("Notice", bodydata, endPointVariableKey)
        const tempData = responsePending?.data?.filter((item) => item?.noticeId == NoticeId)
        console.log("tempData", tempData)
        const approverComment = tempData[0]?.approverComment?.split("\r\n")
        console.log("approverComment", approverComment)
        setApproverComment(approverComment)
        setApproverCommentInput("")
        toast.success(`Notice Approved`);
        setApproveShow(false);
        setLoading(false);
        GetNoticeList();

      } else {
        toast.error(response.message[0]);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      const bodyError = JSON.stringify({
        "userId": UserData.userId,
        "mobileNumber": UserData.mobileNumber, // Need to be change
        "requestJSON": bodydata,
        "uri": "/api/Master/Notice",
        "errorNumber": "DN01",
        "errorSource": ErrorSource,
        "errorSummary": error.message,
        "errorDescription": error.message,
        "fileClassName": "Noticemanagement.js",
        "functionName": "ApprovedUser",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError)

      if (response.success === true && response.message.length == 0) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        toast.error("Something went wrong");
        setLoading(false);
      }

    }

  }

  const handleDocumentChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedDocument(file);
      setUploadDocBtn(true);
    }
  };

  const AddNoticeDocument = async () => {
    // Your existing upload logic — just pass selectedDocument instead of image
    // Example: upload file and push to NoticeImages same as images
  };

  const getFileName = (url) => decodeURIComponent(url.split('/').pop().split('?')[0]);
  const getFileIconFromUrl = (url) => {
    const ext = url.split('.').pop().toLowerCase();
    if (ext === "pdf") return <FontAwesomeIcon icon={faFilePdf} size="3x" className="text-danger" />;
    if (["doc", "docx"].includes(ext)) return <FontAwesomeIcon icon={faFileWord} size="3x" className="text-primary" />;
    if (["xls", "xlsx"].includes(ext)) return <FontAwesomeIcon icon={faFileExcel} size="3x" className="text-success" />;
    return <FontAwesomeIcon icon={faFileAlt} size="3x" className="text-secondary" />;
  };

  const getDocIcon = (type) => {
    if (type.includes("pdf")) return faFilePdf;
    if (type.includes("word")) return faFileWord;
    if (type.includes("excel") || type.includes("spreadsheet")) return faFileExcel;
    return faFileAlt;
  };





  const [file, setFile] = useState();



  return (
    <>
      {Loading ?
        <div className="loaderDiv">
          <div className="loader"></div>
        </div>
        : null}
      <ToastContainer />
      {/* <Menus /> */}
      <section id="client-builder">
        <div className="container-fluid pt-2">
          <div className="row mt-5 pt-2" style={{ alignItem: 'center' }}>
            <div className="col-lg-6 col-md-6 px-0">
              <div className="HeadingTop">
                <h3> Notice Approval </h3>
                <span> Review and verify for new notice {CurrentStatusSelected.charAt(0).toLowerCase() + CurrentStatusSelected.slice(1).toLowerCase()}.</span>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 px-0 mb-2 text-right" style={{ alignContent: 'center' }}>
              <input type="text" className="onlysearch" style={{ padding: "7px 40px 5px 10px", marginRight: 10 }} value={SearchNotice} placeholder='Search' onChange={(e) => filterNoticeData(e.target.value)} />
              <select size="md" className="sltareamodal col-4 ml-auto bg-white" onChange={(e) => {
                console.log("selection", e.target.value)
                setCurrentStatusSelected(e.target.value);
              }}>
                <option value="PENDING">Pending</option>
                <option value="APPROVED">Approved</option>
                <option value="REJECTED">Rejected</option>
                <option value="EXPIRED">Expired</option>
              </select>
            </div>
          </div>

          {/*  BroadCast Modal */}
          <Modal fullscreen={fullscreen} show={Show} onHide={() =>
            setShow(false)} className="modal-100w  modal-fullscreen" aria-labelledby="example-custom-modal-styling-title">
            <Modal.Header className="headerMDL" closeButton>
              <Modal.Title id="example-custom-modal-styling-title">
                Broadcast Notice
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-lg-5 col-md-5 col-sm-12 col-12 pr-0">
                  <div className="row">
                    <div class="col-lg-3 col-md-3 col-sm-12 col-12 mb-3">
                      <div className="form-group">
                        <label for="wfirstName2" style={{ fontSize: "small" }}>
                          {" "}
                          Notice Type {" "}
                          {/* <span className="danger">*</span>{" "} */}
                        </label>
                        <input type="text" className="form-control required" disabled value={NoticeTypeText} onChange={(e) => { setNoticeTypeText(e.target.value); }} />
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-12 col-12 mb-3">
                      <div className="form-group">
                        <label for="wfirstName2" style={{ fontSize: "small" }}>
                          {" "}
                          Importance {" "}
                          {/* <span className="danger">*</span>{" "} */}
                        </label>
                        <input type="text" className="form-control required" disabled value={Importance} onChange={(e) => { setImportance(e.target.value); }} />
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12 col-12 mb-3">
                      <div className="form-group">
                        <label for="wfirstName2" style={{ fontSize: "small" }}>
                          {" "}
                          Effective Start Date {" "}
                          {/* <span className="danger">*</span>{" "} */}
                        </label>
                        <input type="date" className="form-control required" disabled value={StartDate} onChange={(e) => { setStartDate(e.target.value); }} />
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12 col-12 mb-3">
                      <div className="form-group">
                        <label for="wfirstName2" style={{ fontSize: "small" }}>
                          {" "}
                          Effective End Date {" "}
                          {/* <span className="danger">*</span>{" "} */}
                        </label>
                        <input type="date" className="form-control required" disabled value={EndDate} onChange={(e) => { setEndDate(e.target.value); }} />
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="form-group">
                        <label for="wfirstName2" style={{ fontSize: "small" }}>
                          {" "}
                          Notice Subject {" "}
                          {/* <span className="danger">*</span>{" "} */}
                        </label>
                        <input
                          type="text"
                          maxLength={60}
                          className="form-control required"
                          id="wfirstName2"
                          name="firstName"
                          aria-required="true"
                          value={NoticeSubject} disabled onChange={(e) => { setNoticeSubject(e.target.value); }} />
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
                      <div className="form-group">
                        <label for="wfirstName2" style={{ fontSize: "small" }}>
                          {" "}
                          Notice Description {" "}
                          {/* <span className="danger">*</span>{" "} */}
                        </label>
                        <JoditEditor ref={editor} value={content} tabIndex={1} onBlur={newContent =>
                          setContent(newContent)} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-12 col-12 pr-0">
                  <div className="uploadedfilesection" style={{ border: "1px solid #dadada", height: "424px" }}>
                    <span className='modalImageheader'>Images</span>
                    <ul style={{ marginTop: "40px" }}>
                      {NoticeImages ? NoticeImages?.map((item, index) =>
                        <li key={index} >
                          {/* <div className='RelativeDel'>
                                            <FontAwesomeIcon icon={faTimes} onClick={() => ShowDeleteImgModal(item)} className="deleteupload" />
                                        </div> */}
                          {item.fileType === "IMAGE" ? <img src={item?.docImage} className="img img-responsive" /> :
                            <>
                              <a href={item.docImage} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "#333" }}>
                                <div style={{ padding: "20px", border: "2px dashed #ccc", borderRadius: "8px", background: "#f9f9f9" }}>
                                  {getFileIconFromUrl(item.docImage)}
                                  <p style={{ margin: "8px 0 0", fontSize: "12px", wordBreak: "break-all" }}>
                                    {/* {getFileName(item.docImage)} */
                                      item.orginalFileName
                                    }
                                  </p>
                                </div>
                              </a>
                            </>}

                        </li>
                      ) : null}
                      {!NoticeImages?.length ? (NoticeImages?.length == 0 && NoticeImages?.length != null &&
                        <div className='bg-white' style={{ paddingBottom: "50px", borderRadius: "10px" }}>
                          <div className='col-12 text-center'>
                            <img src={noPictures} alt="user" class="mx-auto mt-5" style={{ height: "100px" }} />
                          </div>
                          <br />
                          <h3 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "0px" }}> No Image Found</h3>
                          {/* <h5 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "10px" }}> Click on Create New button to add a Notice</h5> */}
                        </div>) : null}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-12 p-0">
                  <div className="form-group bg-white" >
                    <div className='' style={{ border: "1px solid #dadada", padding: "10px" }}>
                      <span style={{ fontSize: "12px" }}> Broadcast Message</span>
                    </div>

                    <div className="uploadedfilesection" style={{ height: "384px" }}>
                      <div className="card-body row">
                        <div className="col-md-12 mt-3">
                          <label for="wfirstName2">  Tower   </label>
                          <Select
                            // defaultValue={TowerSelected}
                            isMulti

                            options={TowerList}
                            value={TowerSelected}
                            // onChange={(event) =>(setTowerSelected(event))}
                            onChange={handleTowerChange}
                            hidePlaceholder={true}
                            placeholder="All Tower"
                            // selectedValues={TowerSelected} // Preselected value to persist in dropdown
                            // onSelect={(event) =>(setTowerSelected(event))} // Function will trigger on select event
                            // onRemove={(event) =>(setTowerSelected(event))} // Function will trigger on remove event
                            displayValue="name" // Property name to display in the dropdown options

                          />
                          {/* <Multiselect
                                                options={checkBox.options} // Options to display in the dropdown
                                                showCheckbox={true}
                                                selectedValues={TowerSelected} // Preselected value to persist in dropdown
                                                onSelect={(event) =>(setTowerSelected(event))} // Function will trigger on select event
                                                onRemove={(event) =>(setTowerSelected(event))} // Function will trigger on remove event
                                                displayValue="name" // Property name to display in the dropdown options
                                            />  */}
                          {/* flat list shown here */}
                        </div>
                        <div className="col-md-12 mt-3">
                          <label for="wfirstName2">  Flat   </label>
                          <Select
                            isMulti
                            options={FlatList ? FlatList : []}
                            value={FlatSelected}
                            placeholder="All Flats"
                            onChange={handleFlatChange}
                            // selectedValues={FlatSelected} // Preselected value to persist in dropdown
                            // onSelect={(event) =>(FlatSelected(event))} // Function will trigger on select event
                            // onRemove={(event) =>(setFlatSelected(event))} // Function will trigger on remove event
                            displayValue="name" // Property name to display in the dropdown options

                          />
                          {/* <Multiselect
                                                options={FlatcheckBox.options} // Options to display in the dropdown
                                                selectedValues={FlatSelected} // Preselected value to persist in dropdown
                                                onSelect={(event) =>(setFlatSelected(event))} // Function will trigger on select event
                                                onRemove={(event) =>(setFlatSelected(event))} // Function will trigger on remove event
                                                displayValue="name" // Property name to display in the dropdown options
                                            />   */}
                        </div>
                        {/* <div className="col-md-4 mt-3">
                                            <label for="wfirstName2">  Family : <span className="danger">*</span> </label>
                                            <div id="list3" className="dropdown-check-list2" tabindex="100">
                                                <span className="anchor">Select Family</span>
                                                <ul className="items">
                                                    {TowerList ? TowerList.map((item, index) =>  <li key={index}><input type="checkbox" value={item.towerId} style={{position: "relative", opacity: 1, marginRight: 10}} />{item.towerName} </li>): null}
                                                </ul>
                                            </div>
                                        </div>     */}







                      </div>
                      <div className='row mb-5 mt-3'>
                        <div className='col-md-6 text-center'>
                          <button value={"APPROVED"} onClick={() => (BroadCast())} className='col-9 btn btn-info'>Broadcast</button>
                        </div>
                        {/* <div className='col-md-6 text-center'>
                                            <button value={"REJECTED"} onClick={(e) => (ApproveAPi(e.target.value))} className='col-5 btn btn-danger'>Reject</button>
                                        </div>     */}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </Modal.Body>
            <div className="fixed_allbtn">

            </div>
          </Modal>

          {/*  Approve/Reject Modal */}
          <Modal
            scrollable
            fullscreen={true}
            show={ApproveShow}
            onHide={() => setApproveShow(false)}
            className="modal-100w clientmodal"
          >
            <Modal.Header className="headerMDL" closeButton>
              <Modal.Title>Notice Approval</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="row" id="validation">
                <div className="col-12">
                  {/* Update Notice button removed from here */}

                  <form className="validation-wizard wizard-circle wizard clearfix" role="application">
                    <div className="row" style={{ height: "460px" }}>

                      {/* LEFT: NOTICE DETAILS */}
                      <div className="col-lg-7 col-md-7 col-sm-12 col-12">
                        <div className="row">
                          <div className="col-lg-3 col-md-3 col-sm-12 col-12 mb-3">
                            <label>Notice Type <span className="danger">*</span></label>
                            <select
                              className="sltareamodal col-12"
                              value={NoticeTypeId?.[0]?.toString()}
                              onChange={(e) => {
                                const selected = NoticeType.find(t => t.noticeTypeId == e.target.value);
                                setNoticeTypeId(e.target.value);
                                setNoticeTypeText(selected?.noticeTypeText || "");
                              }}
                            >
                              <option value="">Select Type</option>
                              {NoticeType.map((item, idx) => (
                                <option key={idx} value={item.noticeTypeId}>
                                  {item.noticeTypeText}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="col-lg-3 col-md-3 col-sm-12 col-12 mb-3">
                            <label>Importance <span className="danger">*</span></label>
                            <select className="sltareamodal col-12" value={Importance} onChange={(e) => setImportance(e.target.value)}>
                              <option value="High">High</option>
                              <option value="Medium">Medium</option>
                              <option value="Low">Low</option>
                            </select>
                          </div>

                          <div className="col-lg-3 col-md-6 col-sm-12 col-12 mb-3">
                            <label>Effective Start Date <span className="danger">*</span></label>
                            <input type="date" className="form-control" value={StartDate} onChange={(e) => setStartDate(e.target.value)} />
                          </div>

                          <div className="col-lg-3 col-md-6 col-sm-12 col-12 mb-3">
                            <label>Effective End Date <span className="danger">*</span></label>
                            <input type="date" className="form-control" value={EndDate} onChange={(e) => setEndDate(e.target.value)} />
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                            <label>Notice Subject <span className="danger">*</span></label>
                            <input
                              type="text"
                              className="form-control"
                              value={NoticeSubject}
                              onChange={(e) => setNoticeSubject(e.target.value)}
                            />
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                            <label>Notice Description <span className="danger">*</span></label>
                            <JoditEditor ref={editor} value={content} onBlur={setContent} />
                          </div>
                        </div>
                      </div>

                      {/* LEFT SIDE: UPLOAD IMAGE + UPLOAD DOCUMENT (50%-50%) */}
                      <div className="col-lg-3 col-md-3 col-sm-12 col-12 notice_management"
                        style={{ height: "422px", display: "flex", flexDirection: "column", pointerEvents: CurrentStatusSelected === "EXPIRED" || CurrentStatusSelected === "REJECTED" ? 'none' : "flex" }}>

                        {/* TOP 50%: IMAGE UPLOAD (Unchanged) */}
                        <div className="form-group mb-0"
                          style={{
                            flex: 1,
                            borderBottom: "2px solid #e0e0e0",
                            padding: "10px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between"
                          }}>
                          <div>
                            <label className="font-weight-bold text-center d-block mb-2" style={{ fontSize: "13px", color: '#fff' }}>
                              IMAGE UPLOAD
                            </label>

                            {!selectedImageTwo ? (
                              <>
                                <label htmlFor="file-upload-approve" className="custom-file-upload d-block text-center justify-center" style={{ cursor: "pointer" }}>
                                  <img src={noticeImageUpload} className="img img-responsive mb-0" style={{ maxHeight: "80px" }} alt="upload" />
                                </label>
                                <input
                                  id="file-upload-approve"
                                  type="file"
                                  accept="image/jpeg,image/png"
                                  onChange={handleFileInputChangeTwo}
                                  style={{ display: "none" }}
                                />
                              </>
                            ) : (
                              <div className="text-center">
                                <img src={selectedImageTwo} className="img img-responsive rounded" style={{ maxHeight: "80px" }} alt="preview" />
                              </div>
                            )}
                          </div>

                          <div>
                            <label className="text-danger mb-0 d-block" style={{ fontSize: "11px" }}>
                              * Allowed: JPEG/JPG/PNG
                            </label>
                            <label className="text-danger mb-1 d-block" style={{ fontSize: "11px" }}>
                              * Max size: 500KB
                            </label>

                            {UploadBtn ? (
                              <div className="row mx-0">
                                <div className="col-6 pl-0 pr-1">
                                  <button type="button" className="btn btn-sm border bg-white form-control"
                                    onClick={() => { setSelectedImageTwo(null); setSelectedImageTwoShow(null); setUploadBtn(false); }}>
                                    Cancel
                                  </button>
                                </div>
                                <div className="col-6 pr-0 pl-1">
                                  <Button onClick={AddNoticeImage} className="btn-sm form-control border-secondary">Upload</Button>
                                </div>
                              </div>
                            ) : (
                              <div className="row mx-0">
                                <div className="col-6 pl-0 pr-1"><button type="button" className="btn btn-sm border bg-white form-control" disabled>Cancel</button></div>
                                <div className="col-6 pr-0 pl-1"><Button disabled className="btn-sm bg-secondary form-control border-secondary">Upload</Button></div>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* BOTTOM 50%: DOCUMENT UPLOAD */}
                        <div className="form-group mb-0"
                          style={{
                            flex: 1,
                            padding: "10px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between"
                          }}>
                          <div>
                            <label className="font-weight-bold text-center d-block mb-2" style={{ fontSize: "13px", color: '#fff' }}>
                              DOCUMENT UPLOAD
                            </label>

                            {!selectedDocument ? (
                              <>
                                <label htmlFor="doc-upload" className="custom-file-upload d-block text-center" style={{ cursor: "pointer" }}>
                                  <FontAwesomeIcon icon={faFileUpload} size="4x" className="text-muted" />
                                </label>
                                <input
                                  id="doc-upload"
                                  type="file"
                                  accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
                                  onChange={handleDocumentChange}
                                  style={{ display: "none" }}
                                />
                              </>
                            ) : (
                              <div className="text-center">
                                <FontAwesomeIcon icon={getDocIcon(selectedDocument.type)} size="3x" className="text-primary mb-2" />
                                <p className="mb-0 text-truncate" style={{ maxWidth: "100%" }}>{selectedDocument.name}</p>
                              </div>
                            )}
                          </div>

                          <div>
                            <label className="text-danger mb-0 d-block" style={{ fontSize: "11px" }}>
                              * Allowed: PDF, DOC, XLS, TXT
                            </label>
                            <label className="text-danger mb-1 d-block" style={{ fontSize: "11px" }}>
                              * Max size: 5MB
                            </label>

                            {UploadDocBtn ? (
                              <div className="row mx-0">
                                <div className="col-6 pl-0 pr-1">
                                  <button type="button" className="btn btn-sm border bg-white form-control"
                                    onClick={() => { setSelectedDocument(null); setUploadDocBtn(false); }}>
                                    Cancel
                                  </button>
                                </div>
                                <div className="col-6 pr-0 pl-1">
                                  <Button onClick={AddNoticeDocument} className="btn-sm form-control border-secondary">Upload</Button>
                                </div>
                              </div>
                            ) : (
                              <div className="row mx-0">
                                <div className="col-6 pl-0 pr-1"><button type="button" className="btn btn-sm border bg-white form-control" disabled>Cancel</button></div>
                                <div className="col-6 pr-0 pl-1"><Button disabled className="btn-sm bg-secondary form-control border-secondary">Upload</Button></div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* RIGHT SIDE: PREVIEW (Images + Documents) */}
                      <div className="col-lg-2 col-md-2 col-sm-12 col-12 pr-0">
                        <div className="uploadnotice" style={{ height: "422px", display: "flex", flexDirection: "column" }}>

                          {/* Header */}
                          <span style={{ display: "block", textAlign: "center", padding: "8px 0", background: "#f8f9fa", fontWeight: "bold", fontSize: "14px" }}>
                            Uploaded Files Preview
                          </span>

                          <div style={{ flex: 1, overflowY: "auto", padding: "10px" }}>
                            <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
                              {NoticeImages?.length > 0 ? (
                                NoticeImages.map((item, i) => {
                                  const isImg = /\.(jpg|jpeg|png|gif|webp)$/i.test(item.docImage);
                                  return (
                                    <li key={i} style={{ marginBottom: "15px", textAlign: "center", position: "relative" }}>
                                      <div className="RelativeDel">

                                        <FontAwesomeIcon
                                          icon={faTimes}
                                          onClick={() => ShowDeleteImgModal(item)}
                                          className="deleteupload"
                                          style={{ display: CurrentStatusSelected === "EXPIRED" || CurrentStatusSelected === "REJECTED" ? 'none' : "flex" }}
                                        />

                                      </div>

                                      {isImg ? (
                                        <img src={item.docImage} className="img img-responsive" style={{ maxHeight: "120px", borderRadius: "6px" }} alt="preview" />
                                      ) : (
                                        <a href={item.docImage} target="_blank" rel="noopener noreferrer"
                                          style={{ textDecoration: "none", color: "#333" }}>
                                          <div style={{ padding: "20px", border: "2px dashed #ccc", borderRadius: "8px", background: "#f9f9f9" }}>
                                            {getFileIconFromUrl(item.docImage)}
                                            <p style={{ margin: "8px 0 0", fontSize: "12px", wordBreak: "break-all" }}>
                                              {
                                                // getFileName(item.docImage)
                                                item.orginalFileName

                                              }
                                            </p>
                                          </div>
                                        </a>
                                      )}
                                    </li>
                                  );
                                })
                              ) : (
                                <div className="text-center text-muted" style={{ paddingTop: "80px" }}>
                                  <FontAwesomeIcon icon={faFileAlt} size="4x" className="mb-3" style={{ opacity: 0.3 }} />
                                  <h6>No Files Uploaded</h6>
                                </div>
                              )}
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row mx-0"></div>
                    </div>

                    {/* COMMENTS SECTION */}
                    <div className="row mt-3">
                      <div className="col-12">
                        <div className="form-group bg-white">
                          <div style={{ border: "1px solid #dadada", padding: "10px" }}>
                            <span style={{ fontSize: "12px" }}>Comments</span>
                          </div>
                          <div className="uploadedfilesection"
                            style={{ height: "120px", overflowY: "auto", padding: "10px" }}>
                            {ApproverComment.map((c, i) => (
                              <h6 key={i} className="mt-2" style={{ wordWrap: "break-word", fontSize: "13px" }}>
                                {c}
                              </h6>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </Modal.Body>

            {/* FIXED BOTTOM BAR – Wider Comment Box + Approve/Reject on Right */}
            <div className="fixed-bottom bg-white shadow-sm border-top" style={{ padding: "12px 20px", display: CurrentStatusSelected === "EXPIRED" || CurrentStatusSelected === "REJECTED" ? 'none' : "auto" }}>
              <div className="d-flex align-items-center justify-content-between">

                {/* Left: Update Notice Button */}
                {/* <div>
                  <button
                    className="btn btn-warning btn-sm"
                    onClick={UpdateNoticeData}
                    title="Update Notice"
                  >
                    <FontAwesomeIcon icon={faEdit} className="me-1" /> Update Notice
                  </button>
                </div> */}
                <div className="">
                  <button type="button" className="btn btn-info createClr" onClick={UpdateNoticeData}> Update</button>
                </div>

                {/* Right Side: Wider Comment Input + Approve/Reject */}
                <div className="d-flex align-items-center gap-3">

                  {/* Comment Input – NOW WIDER (70% of available space) */}
                  <div style={{ minWidth: "300px", maxWidth: "600px", width: "100%" }} className="flex-grow-1">
                    <div className="position-relative">
                      <input
                        type="text"
                        className="form-control border-primary"
                        placeholder="Add comment (press Enter to send)"
                        value={ApproverCommentInput}
                        onChange={(e) => setApproverCommentInput(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && !e.shiftKey && ApproveAPi("PENDING")}
                        style={{ paddingRight: "50px", fontSize: "14px" }}
                      />
                      <button
                        onClick={() => ApproveAPi("PENDING")}
                        disabled={!ApproverCommentInput.trim()}
                        className="btn btn-link position-absolute end-0 top-50 translate-middle-y"
                        style={{ zIndex: 10 }}
                      >
                        <img src={chat} alt="send" style={{ width: "20px" }} />
                      </button>
                    </div>
                  </div>

                  {/* Approve & Reject Buttons – Fixed on the right */}
                  <div className="d-flex gap-2 flex-shrink-0">
                    <button
                      onClick={ApprovedUser}
                      className="btn btn-success px-4"
                      disabled={Loading}
                    >
                      Approve
                    </button>
                    <button
                      onClick={() => ApproveAPi("REJECTED")}
                      className="btn btn-danger px-4"
                      disabled={Loading}
                    >
                      Reject
                    </button>
                  </div>

                </div>
              </div>
            </div>

            {/* Old Update/Cancel strip removed – now handled in fixed bottom bar */}
          </Modal>


          <div className="row">
            {/* <div className="col-12">
            <div className="card">
               <div className="card-body">
                  <h4 className="card-title">Notice Managment</h4>
                  <div className="table-responsive m-t-20">
                     <div id="example23_wrapper" className="dataTables_wrapper">
                        <table id="example23" className="display nowrap table table-hover table-striped table-bordered dataTable" cellSpacing="0"  role="grid" aria-describedby="example23_info" style={{width: '100%'}}>
                            <thead>
                            <tr role="row">
                                <th className="sorting_asc" tabIndex="0" aria-controls="example23" rowSpan="1" colSpan="1" aria-label="Position: activate to sort column descending" style={{width: '210px'}} aria-sort="ascending">Notice Subject 
                                <FontAwesomeIcon icon={faSort} className='sortclr' />
                                </th>
                                <th className="sorting" tabIndex="0" aria-controls="example23" rowSpan="1" colSpan="1" aria-label="Office: activate to sort column ascending" style={{width: '200px'}}>Notice Type 
                                <FontAwesomeIcon icon={faSort} className='sortclr' />
                                </th>
                                <th className="sorting" tabIndex="0" aria-controls="example23" rowSpan="1" colSpan="1" aria-label="Age: activate to sort column ascending" style={{width: '180px'}}> Notice Description 
                                <FontAwesomeIcon icon={faSort} className='sortclr' />
                                </th>
                                <th className="sorting" tabIndex="0" aria-controls="example23" rowSpan="1" colSpan="1" aria-label="Start date: activate to sort column ascending" style={{width: '180px'}}>Importance 
                                <FontAwesomeIcon icon={faSort} className='sortclr' />
                                </th>
                                <th className="sorting" tabIndex="0" aria-controls="example23" rowSpan="1" colSpan="1" aria-label="Age: activate to sort column ascending" style={{width: '180px'}}> Status 
                                <FontAwesomeIcon icon={faSort} className='sortclr' />
                                </th>
                                {CurrentStatusSelected?.toUpperCase() == "REJECTED" ? null:
                                    <th className="sorting" tabIndex="0" aria-controls="example23" rowSpan="1" colSpan="1" aria-label="Salary: activate to sort column ascending" style={{width: '129px'}}>Take Action</th>
                                }
                            </tr>
                            </thead>
                            <tbody>
                            {NoticeList ? NoticeList.map((item, index) =>  
                            <tr role="row" key={index} className="odd">
                                <td>{item?.noticeSubject}</td>
                                <td>{item?.noticeTypeText}</td>
                                <td><h5 style={{width: 150, overflow: "hidden", textOverflow: "ellipsis", marginTop: 3}}>{item?.noticeDescription}</h5></td>
                                <td>{item?.importance}</td>
                                {item?.currentStatus?.toUpperCase() == "PENDING" ? 
                                <td>Pending</td>
                                :null
                                }
                                {item?.currentStatus?.toUpperCase() == "APPROVED" ? 
                                <td>Approved</td>
                                :null
                                }
                                {item?.currentStatus?.toUpperCase() == "REJECTED" ? 
                                <td>Rejected</td>
                                :null
                                }
                                {CurrentStatusSelected?.toUpperCase() == "REJECTED" ? null:
                                    <td >
                                        {item?.currentStatus?.toUpperCase() == "PENDING" ? 
                                            <button onClick={() => ApproveModal(item)} className='btn btn-info'>Approve</button>
                                            :
                                            null
                                        }
                                        {item?.currentStatus?.toUpperCase() == "APPROVED" ? 
                                            <button onClick={() => BroadCastModal(item)}  className='btn btn-info ml-2'>Broadcast</button>
                                            :null
                                        }
                                    </td>
                                }
                                
                            </tr>
                            ): null}  
                            </tbody>
                        </table>
                     </div>
                  </div>
               </div>
            </div>
         </div> */}
          </div>
          <div className='row'>
            {NoticeList ? NoticeList.map((item, index) =>
              <div key={index} className="OneTile">
                <div className="ex_feild">
                  {item?.importance.toUpperCase() == "MEDIUM" ?
                    <span className="imp_med"> </span>
                    : null}

                  {item?.importance.toUpperCase() == "HIGH" ?
                    <span className="imp_high"> </span>
                    : null}

                  {item?.importance.toUpperCase() == "LOW" ?
                    <span className="imp_Low"> </span>
                    : null}
                </div>
                <div className="NoticeFeild">
                  <h1> {item.noticeSubject}</h1>
                  <h2> {item.noticeTypeText} </h2>

                  <div className="onboardFlex">
                    {/* <h4> Current Status </h4> */}
                    <span> {item.currentStatus} </span>
                  </div>
                  <br />
                  <div className="onboardFlex">
                    <h4> Expiring On <span> {convertISTTime(item.effectiveEndDt)} </span></h4>
                  </div>

                  {item?.currentStatus?.toUpperCase() == "PENDING" ?
                    <div class="bars_font" >
                      <h3
                        className="font_trigger"
                        onClick={() => ApproveModal(item)}>
                        <FontAwesomeIcon icon={faPodcast} />
                      </h3>
                    </div>
                    : null
                  }
                  {item?.currentStatus?.toUpperCase() === "APPROVED" ? (
                    <div className="bars_font" style={{ display: "flex" }}>
                      {(CurrentStatusSelected != "EXPIRED" && CurrentStatusSelected != "REJECTED") ? <h3 className="font_trigger pl-1 pr-1" onClick={() => BroadCastModal(item)}>
                        <FontAwesomeIcon icon={faBullhorn} />
                      </h3> : <h3
                        className="font_trigger pl-1 pr-1"
                        onClick={() => ApproveModal(item)}>
                        <FontAwesomeIcon icon={faPodcast} />
                      </h3>}

                      {/* New History Icon */}
                      <h3 className="font_trigger pl-1 pr-1" onClick={() => openBroadcastHistory(item)} style={{ marginLeft: "10px", color: "#17a2b8" }}>
                        <FontAwesomeIcon icon={faHistory} />
                      </h3>
                    </div>
                  ) : null}

                  {(CurrentStatusSelected === "REJECTED") &&
                    <div className="bars_font" style={{ display: "flex" }}> <h3
                      className="font_trigger"
                      onClick={() => ApproveModal(item)}>
                      <FontAwesomeIcon icon={faPodcast} />
                    </h3>
                    </div>}
                </div>
              </div>
            ) : null}

            {NoticeList?.length == 0 ? (!NoticeList?.length && NoticeList?.length != null &&
              <div className='bg-white' style={{ height: "300px", borderRadius: "10px" }}>
                <div className='col-12 text-center'>
                  <img src={noticeApproval} alt="user" class="mx-auto mt-5" style={{ height: "150px" }} />
                </div>
                <br />
                <h3 className='col-12 text-center' style={{ marginTop: "0px" }}> No Notice Found</h3>
                {/* <h5 className='col-12 text-center' style={{marginTop: "10px"}}> Click on Create New button to add a Notice</h5> */}
              </div>) : null}
          </div>
        </div>
      </section>


      {/* Broadcast History Modal */}
      {/* <Modal
        fullscreen={true}
        show={broadcastHistoryShow}
        onHide={() => setBroadcastHistoryShow(false)}
        className="modal-100w"
      >
        <Modal.Header closeButton className="headerMDL">
          <Modal.Title>
            Broadcast History - {selectedNoticeForHistory?.noticeSubject}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Broadcast Date</th>
                  <th>Tower</th>
                  <th>Flat</th>
                  <th>Status</th>
                  <th>User</th>
                </tr>
              </thead>
              <tbody>
                {broadcastHistoryData.length > 0 ? (
                  broadcastHistoryData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{new Date(item.createdDt).toLocaleString()}</td>
                      <td>{item.towerName || "All Towers"}</td>
                      <td>{item.flatName || "All Flats"}</td>
                      <td>
                        <span className="badge bg-success">Sent</span>
                      </td>
                      <td>{item.createdUserName || "Admin"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-4">
                      <img src={noPictures} alt="no-data" style={{ height: "80px", opacity: 0.5 }} />
                      <br />
                      <strong>No broadcast history found</strong>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal> */}

      {/* Broadcast History Modal - EXACT MATCH TO YOUR DESIGN */}
      <Modal
        fullscreen={true}
        show={broadcastHistoryShow}
        onHide={() => setBroadcastHistoryShow(false)}
        className="modal-100w"
      >
        <Modal.Header closeButton className="headerMDL">
          <Modal.Title>
            Broadcast History - {selectedNoticeForHistory?.noticeSubject || 'Test Subject 20/11'}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-0">

          {/* Header */}
          <div
            className="border-bottom"
            style={{
              padding: '14px 20px',
              marginTop: '10px',
              fontSize: '14px',
              fontWeight: '600',
              backgroundColor: '#d7eefd',
              width: '100%',
              border: '1px solid #ccc'
            }}
          >
            <div className="row align-items-center">
              <div className="col-4">
                <FontAwesomeIcon icon={faCalendarAlt} className="mr-2" /> Broadcast Date
              </div>

              <div className="col-4 text-center">
                <FontAwesomeIcon icon={faBuilding} className="mr-2" /> Tower
              </div>

              <div className="col-4">
                <FontAwesomeIcon icon={faBuilding} className="mr-2" />Flat Number
              </div>
            </div>
          </div>

          {/* Body - Grouped by Date */}
          <div className="bg-white">
            {broadcastHistoryData.length > 0 ? (
              broadcastHistoryData.map((item, index) => (
                <div key={index} className="border-bottom">
                  <div
                    className="row align-items-center"
                    style={{ padding: '2px 20px', minHeight: '52px' }}
                  >

                    {/* Broadcast Date */}
                    <div className="col-4 ">
                      {new Date(item.noticeDeliveredDate).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                      }).replace(/\//g, '/')}{" "}
                      {new Date(item.noticeDeliveredDate).toLocaleTimeString('en-GB', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                      }).toLowerCase()}
                    </div>

                    {/* Tower Circles */}
                    <div className="col-4 text-center">
                      <div className="d-flex justify-content-center gap-2 flex-wrap">
                        {item.lstTower.map((tower, i) => (
                          <span
                            key={i}
                            className="d-inline-flex align-items-center justify-content-center text-black fw-bold px-3 py-1 badge rounded-pill border"
                            style={{
                              fontSize: '13px',
                              backgroundColor: '#e2f8ff',
                              fontWeight: '800'
                            }}
                          >
                            {tower.towerName}
                          </span>
                        ))}
                      </div>
                    </div>

                    {/* Flat Badges */}
                    <div className="col-4">
                      <div className="d-flex flex-wrap gap-2">
                        {item.lstTower.flatMap(tower =>
                          (tower.flatNames || []).map((flat, idx) => (
                            <span
                              key={idx}
                              className="badge rounded-pill px-3 py-1 border fw-bold"
                              style={{
                                backgroundColor: '#f8f9fa',
                                color: '#495057',
                                fontSize: '13px',
                                fontWeight: '500',
                                border: '1px solid #dee2e6'
                              }}
                            >
                              {flat}
                            </span>
                          ))
                        )}

                        {/* If no flats → show "All Flats" */}
                        {item.lstTower.every(t => !t.flatNames || t.flatNames.length === 0) && (
                          <span className="text-muted fst-italic">All Flats</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-5">
                <img src={noPictures} alt="no-data" style={{ height: "100px", opacity: 0.5 }} />
                <h5 className="mt-3 text-muted">No broadcast history found</h5>
              </div>
            )}
          </div>

        </Modal.Body>
      </Modal>



      <Modal centered show={DeleteShowImg} onHide={() => setDeleteShowImg(false)}>
        <Modal.Body className="p-0" style={{ borderRadius: "10px" }}>
          <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
            <div className="FnFtxt">
              <h2>Delete Image</h2>
              <h3>Are you sure you want to delete?</h3>
            </div>
          </div>

          <div
            className="confirmation_btn pb-4 pt-3 px-3"
            style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}
          >
            <div className="both_ConfrmBTN col-6" onClick={DeleteNoticeImages}>
              <Button variant="danger">Delete</Button>
            </div>
            <div className="both_ConfrmBTN col-6" onClick={() => setDeleteShowImg(false)}>
              <Button variant="light">Cancel</Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

    </>)

}
export default NoticeApproval 